import React from "react";
import TeacherBanner from "./TeacherBanner";
import TeacherBenifits from "./TeacherBenifits";
import TeacherIntro from "./TeacherIntro";
import InstructorToolkit from "./InstructorToolkit";
// import { search } from "../Other/requests";

function TeachingPage() {
  return (
      <div className="teacherPage">
          <TeacherBanner />
          <TeacherIntro />
          <TeacherBenifits />
          <InstructorToolkit />
      </div>
  );
}

export default TeachingPage;
